import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IEMVDataFormMeta {
    // Terminal Capacity section information [0-7]
    manualKeyEntry: FormInputMeta;
    onlinePinPermitted: FormInputMeta;
    readMagneticTape: FormInputMeta;
    permittedSignature: FormInputMeta;
    readChip: FormInputMeta;
    supportedSDA: FormInputMeta;
    offlinePinPermitted: FormInputMeta;
    cardCapture: FormInputMeta;
    
    // Terminal Data section information [8-11]
    terminalID: FormInputMeta;
    terminalSerialNumber: FormInputMeta;
    terminalCountry: FormInputMeta;
    terminalTransactionDate: FormInputMeta;

    // Profile Exchange Application section information [12-17]
    offlineSDA: FormInputMeta;
    offlineDDA: FormInputMeta;
    carrierVerification : FormInputMeta;
    issuerAuthentication : FormInputMeta;
    terminalRiskManagement : FormInputMeta;
    combined_DDA_AC_Generation : FormInputMeta;

    // Cryptogram section information [18-23]
    cryptogram: FormInputMeta;
    derivationKeyIndex: FormInputMeta;
    transactionType: FormInputMeta;
    unpredictableNumber: FormInputMeta;
    cryptogramVersion: FormInputMeta;
    applicationTransactionCounter: FormInputMeta;

    // Issuer Scripts section information [24-25]
    issuerScriptResult: FormInputMeta;
    issuerScriptID: FormInputMeta;


  schema: any;
}

const emvDataFormMeta = {} as IEMVDataFormMeta;

// Terminal Capacity section information
emvDataFormMeta.manualKeyEntry = {
  name: "manualKeyEntry",
  type: "checkbox",
  label: "Clée Manuelle Entrée",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

emvDataFormMeta.onlinePinPermitted = {
  name: "onlinePinPermitted",
  type: "checkbox",
  label: "Online Pin Permis",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

emvDataFormMeta.readMagneticTape = {
  name: "readMagneticTape",
  type: "checkbox",
  label: "Bande Magnétique Lue",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

emvDataFormMeta.permittedSignature = {
  name: "permittedSignature",
  type: "checkbox",
  label: "Signature Permise",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

emvDataFormMeta.readChip = {
  name: "readChip",
  type: "checkbox",
  label: "Puce Lue",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

emvDataFormMeta.supportedSDA = {
  name: "supportedSDA",
  type: "checkbox",
  label: "SDA Supporté",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

emvDataFormMeta.offlinePinPermitted = {
  name: "offlinePinPermitted",
  type: "checkbox",
  label: "Offline Pin Permis",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

emvDataFormMeta.cardCapture = {
  name: "cardCapture",
  type: "checkbox",
  label: "Offline Pin Permis",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

// Terminal Data section information
emvDataFormMeta.terminalID = {
  name: "terminalID",
  type: "text",
  label: "ID Terminal",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

emvDataFormMeta.terminalSerialNumber = {
  name: "terminalSerialNumber",
  type: "text",
  label: "Numéro Série Terminal",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

emvDataFormMeta.terminalCountry = {
  name: "terminalCountry",
  type: "text",
  label: "Pays Terminal",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

emvDataFormMeta.terminalTransactionDate = {
  name: "terminalTransactionDate",
  type: "text",
  label: "Date Transaction Terminal",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

// Profile Exchange Application section information
emvDataFormMeta.offlineSDA = {
  name: "offlineSDA",
  type: "checkbox",
  label: "Offline SDA",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

emvDataFormMeta.offlineDDA = {
  name: "offlineDDA",
  type: "checkbox",
  label: "Offline DDA",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

emvDataFormMeta.carrierVerification = {
  name: "carrierVerification",
  type: "checkbox",
  label: "Vérification Porteur",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

emvDataFormMeta.issuerAuthentication = {
  name: "issuerAuthentication",
  type: "checkbox",
  label: "Authentification Emetteur",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

emvDataFormMeta.terminalRiskManagement = {
  name: "terminalRiskManagement",
  type: "checkbox",
  label: "Gestion Risque Terminal",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

emvDataFormMeta.combined_DDA_AC_Generation = {
  name: "combined_DDA_AC_Generation",
  type: "checkbox",
  label: "Generation DDA/AC Combiné",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

// Cryptogram section information
emvDataFormMeta.cryptogram = {
    name: "cryptogram",
    type: "text",
    label: "Cryptogram",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

emvDataFormMeta.derivationKeyIndex = {
    name: "derivationKeyIndex",
    type: "text",
    label: "Derivation Key Index",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

emvDataFormMeta.transactionType = {
    name: "transactionType",
    type: "text",
    label: "Type Transaction",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

emvDataFormMeta.unpredictableNumber = {
    name: "unpredictableNumber",
    type: "text",
    label: "Unpredictable Number",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

emvDataFormMeta.cryptogramVersion = {
    name: "cryptogramVersion",
    type: "text",
    label: "Version Cryptogram",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

emvDataFormMeta.applicationTransactionCounter = {
    name: "applicationTransactionCounter",
    type: "text",
    label: "Compteur Transaction Application",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

// Scripts Issuer section information
emvDataFormMeta.issuerScriptResult = {
    name: "issuerScriptResult",
    type: "text",
    label: "Résultat Script Emetteur",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

emvDataFormMeta.issuerScriptID = {
    name: "issuerScriptID",
    type: "text",
    label: "Identifiant Script Emetteur",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};


emvDataFormMeta.schema = yup.object().shape(getValidationSchema(emvDataFormMeta));

export default emvDataFormMeta;